import React from "react";
import "./Authenticity.css";
import Image from "../../assets/Rectangle4.png.webp";

const Authenticity: React.FC = () => {
  return (
    <section className="authenticity-section">
      <div className="authenticity-frame">
        {/* Image Section */}
        <div className="authenticity-image">
          <img loading="lazy" decoding="async" src={Image} alt="Living Room" />
        </div>

        {/* Text Content Section */}
        <div className="authenticity-content">
          <div className="authenticity-header">
            <h2>Logistics</h2>
            <div className="red-underline"></div>
          </div>
          <p className="authenticity-description">
            Our warehouse is located in Colombo 15 with a 30,000 sq. ft facility
            with all amenities and easy access, with a state of the art ERP
            system to ensure the smooth functioning of the operation. The
            transport fleet consists of our own vehicles and outsourced
            roadworthy vehicles with a trained and disciplined staff to ensure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Authenticity;
